import 'angular:locale/data:en';
import './apps/client-portal/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "en";
